(function() {

    'use strict';

    angular.module('app').
    controller('CarriersServicesController', CarriersServicesController);

    CarriersServicesController.$inject = ['$scope', 'Carrier', 'ServiceProfileTableService','$routeParams'];

    function CarriersServicesController($scope, Carrier, ServiceProfileTableService, $routeParams) {

        let vm = this;
        let carrierProfileId = $routeParams.carrierProfileId;
        let carerProfileName = $routeParams.name;

        init();

        function init() {
            let paginationData = {
                size: 5,          
                page: 0,
                sort: 'clientId'
            };
            getCarriers(paginationData);
        }

        function getCarriers (requestPagination, filters) {
            let requestData = {};
            angular.extend(requestData, requestPagination, filters);
            
            Carrier.getCarriers(function(data) {
            }, function(err) {
                console.log(err);
            }, requestData).getServices((services)=>{
                vm.serviceProfiles = new ServiceProfileTableService(services, carrierProfileId, carerProfileName).tableData;
            });
        };
    }
})();



// WEBPACK FOOTER //
// ./js/controllers/carriers/CarrierServiceController.js